import { render } from "./AppCombinationColorsCanvasModal.vue?vue&type=template&id=30a2a4ac&scoped=true&ts=true"
import script from "./AppCombinationColorsCanvasModal.vue?vue&type=script&lang=ts"
export * from "./AppCombinationColorsCanvasModal.vue?vue&type=script&lang=ts"

import "./AppCombinationColorsCanvasModal.vue?vue&type=style&index=0&id=30a2a4ac&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a2a4ac"]])

export default __exports__